/* ============================================================
   Notre Chanson — currency-select.js
   Menu déroulant pays/devise du header : ouverture/fermeture et
   fermeture au clic dehors. Les drapeaux sont des images (flagcdn).
   Le changement de marché est fait par les boutons submit du
   formulaire de localisation Shopify (aucune logique de switch ici).
   ============================================================ */
(function () {
  'use strict';

  function closeAll(except) {
    document.querySelectorAll('[data-cur].is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var t = w.querySelector('[data-cur-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('[data-cur]').forEach(function (wrap) {
    var toggle = wrap.querySelector('[data-cur-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAll(wrap);
      var open = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
